/**
 * The selected template's read-only preview, with the current board's column
 * settings attached so status cells show their label colours, as the editor
 * does. Until the board arrives, or if it can't be read, they stay grey.
 */
import React, { useMemo } from 'react';
import { withBoardSettings } from '../lib/boardSettings';
import useBoardColumns from '../lib/useBoardColumns';
import useItemBoardColumns from '../lib/useItemBoardColumns';
import { GroupTemplateView } from './GroupTemplateEditor';
import SubitemsTable from './SubitemsTable';

export function SubitemTemplatePreview({ monday, itemId, boardId, template }) {
  const board = useBoardColumns(monday, itemId, boardId);
  const columns = useMemo(() => withBoardSettings(template.columns || [], board.columns), [template.columns, board.columns]);
  return <SubitemsTable columns={columns} subitems={template.subitems} readOnly />;
}

export function GroupTemplatePreview({ monday, itemId, boardId, template }) {
  const itemBoard = useItemBoardColumns(monday, itemId, boardId);
  const subBoard = useBoardColumns(monday, itemId, boardId);
  return <GroupTemplateView content={template.content} itemBoardColumns={itemBoard.columns} subitemBoardColumns={subBoard.columns} />;
}
